<template>
  <div class="gallery-component">
    <div class="gallery">
      <lingallery :iid.sync="currentId" :width="width" :items="images" :showThumbnails="false"/>
    </div>
  </div>
</template>
<script>

import Lingallery from 'lingallery';
export default {
    props: {
        images: {
            Array,
            default: () => ([])
        },
    },
    
    data() {
        return {
            width: 2048,
            height: 400,
            currentId: null};
    },
    components: {
      Lingallery
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.gallery-component {
    display: flex;
    width: 100%;
    justify-content: center;

}

.gallery {
    width: 70%;
}
.gallery /deep/ .lingalleryContainer {
}

.gallery /deep/ .lingallery_thumbnails {
    display: flex;
}

.gallery /deep/ .lingallery_thumbnails_content {
    margin-left: auto;
    margin-right: auto;
    
}

</style>
